module.exports = __webpack_public_path__ + "img/icon-bmkg.b1f4f4c6.png";